import { gql } from '@apollo/client';

export const GET_PROGRAM_ACTIVITIES = gql`
  query GetProgramActivities($rule: VOLUNTEER_VolunteerManagementPrivilegeRulesEnumType) {
    vm {
      programs(hasRule: { rule: $rule }) {
        programId
        name
        dateDeleted
        dateSuspended
      }
    }
  }
`;

export const GET_PROGRAM_ACTIVITIES_VOL_DB = gql`
  query GetProgramActivitiesVolDB($rule: VOLUNTEER_VolunteerManagementPrivilegeRulesEnumType) {
    vm {
      programs(hasRule: { rule: $rule }) {
        programId
        name
        dateDeleted
        dateSuspended
        activities {
          activityId
          name
          program {
            programId
          }
        }
      }
      activityRoles {
        activityRoleId
        icon
        name
      }
    }
  }
`;